// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BasicInfoSection__wrap--2x5fc"};